import Splide from '@splidejs/splide';

/**
 * Merch Carousel Lazy Load
 */
(() => {
  // Splide configuration
  const SPLIDE_CONFIG = {
    type: 'slide',
    perPage: 5,
    perMove: 1,
    gap: 30,
    arrows: true,
    pagination: true,
    breakpoints: {
      1469: {
        perPage: 4,
        perMove: 4,
      },
      1110: {
        perPage: 3,
        perMove: 3,
      },
      838: {
        perPage: 2,
        perMove: 2,
      },
      565: {
        perPage: 1,
        perMove: 1,
      },
    },
  };

  // Function to show error state
  function showErrorState(splideList) {
    splideList.innerHTML = `
      <div class="splide__slide error-state">
        <p>Failed to load content. Please try again later.</p>
      </div>
    `;
  }

  // Function to create loading placeholder
  function createLoadingPlaceholder() {
    const placeholder = document.createElement('div');
    placeholder.className = 'splide__slide loading-placeholder';
    placeholder.innerHTML = `
      <div class="product-card">
        <div class="product-image skeleton"></div>
        <div class="product-info">
          <div class="product-title skeleton"></div>
          <div class="product-price skeleton"></div>
        </div>
      </div>
    `;
    return placeholder;
  }

  // Function to process product HTML
  function processProductHtml(child) {
    try {
      const image = child.querySelector('.imgthumbnail img')?.outerHTML;
      const title = child.querySelector('.product-name')?.outerHTML;
      const sku = child.querySelector('.product-sku')?.innerHTML;
      const link = child.querySelector('.product-name a')?.href;

      if (!image || !title || !sku || !link) {
        console.warn('Missing required product elements:', {
          image, title, sku, link,
        });
        return null;
      }

      const product = document.createElement('div');
      product.classList.add('product-card', 'splide__slide');

      product.innerHTML = `
        <div class="product-image">
          ${image}
        </div>
        <div class="product-info">
          ${title}
          <div class="product-sku">${sku}</div>
        </div>
        <a href="${link}" class="btn-custom primary">Find Out More</a>
      `;
      return product.outerHTML;
    } catch (error) {
      console.error('Error processing product HTML:', error);
      return null;
    }
  }

  // Function to load the merch slider content
  function loadMerchSlider(merchSlider) {
    const merchId = merchSlider.getAttribute('data-merch');
    const splideList = merchSlider.querySelector('.splide__list');
    if (!merchId || !splideList) {
      console.warn('Missing required elements:', { merchId, splideList });
      return;
    }

    // Add loading placeholders
    const loadingPlaceholders = Array.from({ length: 5 }, () => createLoadingPlaceholder());
    splideList.innerHTML = loadingPlaceholders.map((placeholder) => placeholder.outerHTML).join('');

    // Initialize Splide with loading state
    const splide = new Splide(merchSlider.querySelector('.splide'), SPLIDE_CONFIG).mount();

    $.ajax({
      type: 'post',
      url: '/ajax/merchandising',
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
      data: { groupMerchandising_ids: [merchId] },
      success(response) {
        const merchandisingHtml = response.data.itemmerchandisinghtml;
        if (!merchandisingHtml) {
          console.warn('No merchandising HTML received');
          return;
        }

        try {
          // Process the HTML content
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = Object.values(merchandisingHtml)[0].trim();

          const processedHtml = Array.from(tempDiv.children)
            .map(processProductHtml)
            .filter(Boolean) // Remove any null entries from failed processing
            .join('');

          if (!processedHtml) {
            throw new Error('No valid products to display');
          }

          splideList.innerHTML = processedHtml;

          // Reinitialize Splide with actual content
          splide.destroy();
          new Splide(merchSlider.querySelector('.splide'), SPLIDE_CONFIG).mount();

          window.fetchLiveData();
        } catch (error) {
          console.error('Error processing merchandising HTML:', error);
          showErrorState(splideList);
        }
      },
      error(err) {
        console.error('Error fetching merchandising data:', err);
        showErrorState(splideList);
      },
    });
  }

  // Create an intersection observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const merchSlider = entry.target;
        loadMerchSlider(merchSlider);
        // Once loaded, we don't need to observe this element anymore
        observer.unobserve(merchSlider);
      }
    });
  }, {
    rootMargin: '200px 0px', // Start loading when slider is 50px from viewport
    threshold: 0.1,
  });

  // Start observing all merch sliders
  document.querySelectorAll('.merch-slider').forEach((merchSlider) => {
    observer.observe(merchSlider);
  });
})();
